module.exports = __webpack_public_path__ + "img/step2-desktop.293819d3.jpg";